export const initYoutubeVideos = () => {
  const youtube_videos_selector = '.youtube';
  const youtube = document.querySelectorAll(youtube_videos_selector);

  const translations = {
    bg: { loading: 'Зареждане на видео…' },
    cs: { loading: 'Načítání videa…' },
    da: { loading: 'Indlæser video…' },
    de: { loading: 'Video wird geladen…' },
    en: { loading: 'Loading video…' },
    es: { loading: 'Cargando video…' },
    fi: { loading: 'Videon lataus…' },
    fr: { loading: 'Chargement de la vidéo…' },
    hr: { loading: 'Učitavanje videa…' },
    hu: { loading: 'Videó betöltése…' },
    it: { loading: 'Caricamento video…' },
    lt: { loading: 'Įkeliama vaizdo įrašas…' },
    nl: { loading: 'Video wordt geladen…' },
    pl: { loading: 'Ładowanie wideo…' },
    pt: { loading: 'Carregando vídeo…' },
    ro: { loading: 'Se încarcă videoclipul…' },
    sk: { loading: 'Načítava sa video…' },
    sv: { loading: 'Laddar video…' },
  };

  const pageLang = document.documentElement.lang.slice(0, 2).toLowerCase();
  const msgs = translations[pageLang] || translations.en;

  if (!document.getElementById('videoStatus')) {
    const liveRegion = document.createElement('div');
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.classList.add('sr-only');
    liveRegion.id = 'videoStatus';
    document.body.appendChild(liveRegion);
  }

  for (let i = 0; i < youtube.length; i++) {
    const wrapper = youtube[i];

    const image = new Image();
    image.src = wrapper.dataset.holder || '';
    image.alt = wrapper.dataset.alt || '';
    image.loading = 'lazy';
    image.addEventListener(
      'load',
      (function () {
        wrapper.appendChild(image);
      })(i),
    );

    wrapper.addEventListener('click', function () {
      wrapper.setAttribute('aria-busy', 'true');
      document.getElementById('videoStatus').textContent = msgs.loading;

      const iframe = document.createElement('iframe');
      const embed = parseEmbedId(this.dataset.embed);
      let iframeLink = `https://www.youtube.com/embed/${embed.base}?rel=0&showinfo=0&autoplay=1&enablejsapi=1`;
      if (embed.time) iframeLink += `&start=${embed.time}`;

      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowsfullscreen', '');
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      iframe.src = iframeLink;

      iframe.addEventListener('load', () => {
        wrapper.removeAttribute('aria-busy');
        document.getElementById('videoStatus').textContent = '';
      });

      this.innerHTML = '';
      this.appendChild(iframe);
    });
  }

  const observer = new IntersectionObserver(
    entries => {
      for (let j = 0; j < entries.length; j++) {
        const entry = entries[j];
        if (!entry.isIntersecting) {
          const iframe = entry.target.querySelector('iframe');
          if (iframe && iframe.contentWindow) {
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        }
      }
    },
    { threshold: 0 },
  );

  for (let k = 0; k < youtube.length; k++) {
    observer.observe(youtube[k]);
  }
};

function parseEmbedId(input) {
  let base = input;
  let time = '';

  if (input.includes('&t=')) {
    const [basePart, timePart] = input.split('&t=');
    base = basePart;
    time = parseInt(timePart.replace('s', ''), 10);
  }

  return { base, time };
}
